module.exports = __webpack_public_path__ + "img/modelo-pp2.a9780e03.png";